import { createContext, useState, useContext } from "react";

// Create a new context object
const OrderContext = createContext();

// Create a custom hook to use the OrderContext
export const useOrder = () => {
  return useContext(OrderContext);
};

// Create the OrderProvider component
export const OrderProvider = ({ children }) => {
  const [reportUnSeenCount, setReportUnSeenCount] = useState(0);

  const DecrementReportUnSeenCount = () => {
    reportUnSeenCount < 1
      ? setReportUnSeenCount(0)
      : setReportUnSeenCount((prev) => prev - 1);
  };

  // Context value object
  const value = {
    reportUnSeenCount,
    setReportUnSeenCount,
    DecrementReportUnSeenCount,
  };

  // Provide the context value to the entire app
  return (
    <OrderContext.Provider value={value}>{children}</OrderContext.Provider>
  );
};
